/**
 * Partner logo slider (template-parts/partners-slider.php).
 * Runs on Slick (imported globally in src/theme.js). The theme's own arrow
 * buttons are handed to Slick as prevArrow/nextArrow, so markup and styling
 * stay ours while dragging, swiping and paging come from the library.
 */
jQuery(function ($) {
    const $track = $('.partners__track');

    if (!$track.length) {
        return;
    }

    $track.slick({
        infinite: true,
        speed: 300,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        prevArrow: $('.partners__arrow--prev'),
        nextArrow: $('.partners__arrow--next'),
        mobileFirst: true,
        responsive: [
            { breakpoint: 640, settings: { slidesToShow: 4 } },
            { breakpoint: 1024, settings: { slidesToShow: 7 } },
        ],
    });
});
